import React from 'react';
import GmailOAuthSimple from '../components/auth/GmailOAuthSimple';
import BetaBannerTest from '../components/test/BetaBannerTest';

const TestPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto space-y-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Test Page
        </h1>
        
        {/* Beta Banner Test */}
        <BetaBannerTest />
        
        {/* Gmail OAuth Test */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Gmail OAuth Test</h2>
          
          <GmailOAuthSimple
            onSuccess={(oauthData) => {
              console.log('OAuth Success:', oauthData);
              alert(`Success! Email: ${oauthData.email}`);
            }}
            onError={(error) => {
              console.error('OAuth Error:', error);
              alert(`Error: ${error}`);
            }}
            buttonText="Test Gmail Connection"
            showConsentMessage={true}
          />
        </div>
      </div>
    </div>
  );
};

export default TestPage;
